;(function () {
	const initSection = (section) => {
		if (section._initialized) return
		section._initialized = true

		const videoSection = section.querySelector('.video-section')
		const stage = section.querySelector('.video-section__stage')
		const content = section.querySelector('.video-section__content')

		if (!videoSection || !stage) return

		const isAnimation = section.dataset.animation === 'true'

		function resetStage() {
			stage.style.width = '100%'
			stage.style.borderRadius = '0'
			stage.style.overflow = ''
			if (content) {
				content.style.opacity = ''
			}
		}

		function changeSectionSizes() {
			const sectionTop = section.getBoundingClientRect().top
			const windowHeight = window.innerHeight
			const windowWidth = window.innerWidth

			if (sectionTop <= 0 && windowWidth >= 750 && isAnimation) {
				const scrollProgress = Math.abs(sectionTop) / windowHeight
				const clampedProgress = Math.min(Math.max(scrollProgress, 0), 1)
				const newSize = 100 - 30 * clampedProgress

				if (content) {
					content.style.opacity = `${clampedProgress}`
				}

				if (newSize <= 75) {
					stage.style.borderRadius = 'var(--border-radius-main)'
					stage.style.overflow = 'hidden'
				} else {
					stage.style.borderRadius = '0'
				}

				stage.style.width = `${newSize}%`
			} else if (isAnimation) {
				resetStage()
			}
		}

		section._scrollHandler = changeSectionSizes

		if (isAnimation && window.innerWidth >= 750) {
			window.addEventListener('scroll', changeSectionSizes)
			changeSectionSizes()
		}
	}

	const initAllSections = () => {
		document.querySelectorAll('.video-section-container').forEach((section) => {
			initSection(section)
		})
	}

	initAllSections()

	document.addEventListener('shopify:section:load', function (event) {
		const loadedSection = event.target?.querySelector('.video-section-container')
		if (loadedSection) {
			loadedSection._initialized = false
			initSection(loadedSection)
		} else {
			initAllSections()
		}
	})

	window.addEventListener('resize', () => {
		document.querySelectorAll('.video-section-container').forEach((section) => {
			if (section._scrollHandler) {
				window.removeEventListener('scroll', section._scrollHandler)
				section._scrollHandler = null
			}
			const stage = section.querySelector('.video-section__stage')
			const content = section.querySelector('.video-section__content')
			if (stage) {
				stage.style.width = '100%'
				stage.style.borderRadius = '0'
				stage.style.overflow = ''
			}
			if (content) {
				content.style.opacity = ''
			}
			section._initialized = false
		})
		initAllSections()
	})
})()
